export default __webpack_public_path__ + "static/media/Pretendard-SemiBold.a0c72d61.woff";